import { ConfluenceExtension } from '@atlassian/forge-ui-types/extension';

export const FULLSCREEN_SUPPORTED_EXTENSION_TYPES: Set<string> = new Set<string>([
	ConfluenceExtension.MACRO,
	ConfluenceExtension.BYLINE,
]);
